import React from 'react'
import { PlanType } from './type'
import { Plan } from './Plan'

type PlanListType = PlanType[]

export const PlanList = (props: { planList: PlanListType }) => {
  const { planList } = props
  const roomTypeOrders = ['保育園留学の寮', '一棟貸し', 'アパートメントホテル', 'ホテル', '旅館', 'ゲストハウス', '民宿']
  const plansGroupedByRoomType = roomTypeOrders
    .map((roomType) => ({
      roomType,
      plans: planList.filter((plan) => plan.room.roomType === roomType),
    }))
    .filter((group) => group.plans.length > 0)

  if (planList.length === 0) {
    const consultationImageUrl = document.getElementById('lp-availability')?.dataset?.consultationImageUrl
    return (
      <>
        <p className="px-4 pb-4 font-semibold leading-6">現在の条件では該当する空き日程がありません。</p>
        <div id="consultation">
          <div className="consultation-wrapper">
            <div className="image">
              <img src={consultationImageUrl} alt="consultation" className="rounded-12" />
            </div>
            <div className="content">
              <div className="block w-full">
                <h3 className="font-size-18 tracking-wider font-a1 text-green text-left md:text-center mb-2 md:font-size-28">
                  留学先選びに迷ったら
                </h3>
                <div className="font-size-14 tracking-wider gallery-item-text text-left md:text-center">
                  保育園留学に行きたいけれど、どんなふうに留学先を選んだら良いかわからない
                </div>
                <div className="font-size-14 tracking-wider gallery-item-text text-left md:text-center mb-6">
                  そんな方のために、さまざまなサービスをご用意しております。
                </div>
              </div>
              <div className="flex flex-wrap justify-center text-center gap-2 consultation-margin">
                <div className="circle-text">
                  <div className="font-size-12 md:font-size-20">
                    留学先の
                    <br />
                    ご提案
                  </div>
                </div>
                <div className="circle-text">
                  <div className="font-size-12 md:font-size-20">
                    トータル予算の
                    <br />
                    ご案内
                  </div>
                </div>
                <div className="circle-text">
                  <div className="font-size-12 md:font-size-20">
                    留学プランの
                    <br />
                    ご相談
                  </div>
                </div>
              </div>
              <div className="block w-full">
                <h3 className="font-size-18 tracking-wider font-a1 text-green text-left md:text-center mb-2 md:font-size-28">
                  LINEで相談
                </h3>
                <div className="text-left mb-4 md:text-center md:mb-8">
                  <p className="font-size-14 tracking-wider gallery-item-text">
                    チャット（会話）でいただいたご質問に、プランナーがお答えします。
                  </p>
                  <p className="font-size-14 tracking-wider gallery-item-text">【受付】平日 9:00 - 18:00（土日祝休）</p>
                </div>
                <button className="bg-green text-white w-full text-center px-6 py-3 rounded-md font-size-14 mx-auto block md:font-size-16 md:py-4">
                  <a
                    href="https://liff.line.me/2002843084-E1bqwPzZ/landing?follow=%40007nfzzj&lp=CxMUwm&liff_id=2002843084-E1bqwPzZ"
                    target="_blank"
                    rel="noopener"
                  >
                    LINEで相談する（お友だち追加）
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      {plansGroupedByRoomType.map((group, index) => (
        <div key={index} className="mb-4">
          <div className="font-size-18 font-bold mb-3 ml-3 md:ml-0">{group.roomType}</div>
          {group.plans.map((plan, planIndex) => (
            <Plan plan={plan} key={planIndex} />
          ))}
        </div>
      ))}
    </>
  )
}
